export enum RoleEnum {
    ADMIN = 1,
    CANDIDATE = 2,
    COUNSELOR_CADIDATE = 3,
    EMPLOYER = 4,
    COUNSELOR_EMPLOYER=5,
    PROVISIONAL = 6
};